<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} Cinema Type</div>
      <router-link class="btn-blue" :to="{name:'Cinema Types'}">Cinema Types {{ $tc("list") }}</router-link>
    </div>
    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Cinema Type Name:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{cinema_type_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Cinema Type is active:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{cine_type_is_active == 'Y' ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      submitted: false,
      cinema_type_name: "",
      cine_type_is_active: 'Y',
      cinema_type_id: null,
    };
  },
   mounted() {
       const {cinema_type_id} = this.$route.params;
       if(cinema_type_id){
         this.getCinemaTypeData(cinema_type_id) 
      }else{
          this.$router.go(-1)
      }
  },
  methods: {
       getCinemaTypeData: function(cinema_type_id) {
        MasterService.GetCinemaTypeData({cinema_type_id:cinema_type_id})
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.cinema_type_name = data.Records[0].cinema_type_name;
              this.cine_type_is_active = data.Records[0].cine_type_is_active;
              this.cinema_type_id = data.Records[0].cinema_type_id;
            } else {
              this.$toasted.show(data.message)
            }
          })
          .catch(error => {
            this.$toasted.show(error)
          });
      
    },
    // editCinemaType() {
    //   this.submitted = true;
    //   this.$validator.validate().then(valid => {
    //     if (valid) {
    //       // let loader = this.$loading.show();

    //       // console.log("JSON.stringify :", JSON.stringify(finalObj));
    //       let payload = {
    //           cinema_type_id: this.cinema_type_id,
    //         cinema_type_name: this.cinema_type_name,
    //         cine_type_is_active: this.cine_type_is_active
    //       };
    //       MasterService.EditCinemaType(payload)
    //         .then(response => {
    //           const { data } = response;
    //           // loader.hide();
    //           if (data && data.status) {
    //             this.$toasted.show(data.message);

    //             this.$router.push({
    //               path: "/master/cinema-types"
    //             });
    //           } else {
    //             this.$toasted.show(data.message);
    //           }
    //         })
    //         .catch(this._CatchError);
    //     } else {
    //       this.$toasted.show("Please enter all details");
    //     }
    //   });
    // }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CinemaTypeComponents/viewCinemaType.vue